import react from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import { Stack, Divider, Typography } from '@mui/material'
import Slider from "react-slick"

function SliderArrow(props) {
  const { className, style, onClick } = props
  
  return (
    <div
      className={className}
      style={{ ...style, display: "block" }}
      onClick={onClick}
    />
  )
}

const ZoneSlider = ({ data, space, setSpace }) => {
  const { t } = useTranslation()

  const navigate = useNavigate()

  const translate_permit_status = (status) => {
    switch (status) {
      case -100:
        return "Missing"
      case -101:
        return "Expired"
      case 102:
        return "Voided"
      case 0:
        return "Pending"
      case 100:
        return "Issued"
      case 101:
        return "Cancelled"
      default:
        return "-"
    }
  }

  return (
    <Slider style={{ height: "100%" }}
      infinite={false} speed={500} slidesToShow={2} slidesToScroll={1}
      nextArrow={<SliderArrow />} prevArrow={<SliderArrow />}
      responsive={[{ breakpoint: 1200, settings: { slidesToShow: 1 } }]}
    >
      {data.map((i) => {
        return (
          <div>
            <div style={{ border: i["location"] === space["location"] ? '2px solid white' : "2px solid #808080", padding: "5px", borderRadius: "15px", cursor: "pointer" }} onClick={() => setSpace(i)}>
              <div style={{ borderRadius: "15px" }}>
                <div style={{ backgroundColor: "#404040", borderRadius: "10px" }}>
                  <div style={{ paddingLeft: "10px", color:"white" }}>{i["location_name"]}</div>
                  <div style={{ paddingLeft: "10px", color:"white" }}>{i["address"]}</div>

                  <div style={{ backgroundColor: "#D3D3D3", borderRadius: "0px 0px 10px 10px", height: "100%" }}>
                    <Stack direction="row" divider={<Divider orientation="vertical" flexItem />} spacing={1} sx={{ height: "100%", justifyContent: "space-around", paddingLeft: "20px", paddingRight: "20px" }}>
                      <div style={{ display: "flex", flexDirection: "column", justifyContent: "center" }}>
                        <div style={{ flexGrow: 1, width: "100%", display: "flex", justifyContent: "center", alignItems: "center" }}>
                          <Typography sx={{ display: '-webkit-box', overflow: 'hidden', WebkitBoxOrient: 'vertical', WebkitLineClamp: 1 }} variant="body1">
                            Working Permit
                          </Typography>
                        </div>

                        <div style={{ flexGrow: 1, display: "flex", flexDirection: "column", alignItems: "center" }}>
                          {i["ptw"] != null ? (
                            <div style={{ display: "grid", gridTemplateColumns: "40px auto" }}>
                              {(i["ptw"]["status"] != null) ? (<>
                                <div className={i["ptw"]["status"] > 0 ? 'text-normal' : 'text-alert'} style={{ cursor: "pointer" }} onClick={() => navigate(`../permit_to_work/list/${i["ptw"]["template"]}/${i["ptw"]["form_id"]}`)}><u>{translate_permit_status(i["ptw"]["status"])}</u></div>
                              </>) : (<>
                                <div>-</div>                        
                              </>)}
                            </div>
                          ) : ("-")}
                        </div>
                      </div>

                      {/* <div style={{ display: "flex", flexDirection: "column", justifyContent: "center" }}>
                        <div style={{ width: "100%", display: "flex", justifyContent: "center", alignItems: "center" }}>
                          <Typography sx={{ display: '-webkit-box', overflow: 'hidden', WebkitBoxOrient: 'vertical', WebkitLineClamp: 1 }} variant="body1">
                            Lock
                          </Typography>
                        </div>

                        <div style={{ flexGrow: 1, display: "flex", justifyContent: "center", alignItems: "center" }}>
                          {i["smart_lock"]["status"] != null ? (<>
                            <div className={!i["smart_lock"]["alert"] ? 'text-normal' : 'text-alert'}>{i["smart_lock"]["status"] ? t("smartlock_locked") : t("smartlock_opened")}</div>
                          </>) : (
                            <div>-</div>
                          )}
                          </div>
                      </div> */}

                      <div style={{ display: "flex", flexDirection: "column", justifyContent: "center" }}>
                        <div style={{ width: "100%", display: "flex", justifyContent: "center", alignItems: "center" }}>
                          <Typography sx={{ display: '-webkit-box', overflow: 'hidden', WebkitBoxOrient: 'vertical', WebkitLineClamp: 1 }} variant="body1">
                            Gas Monitor
                          </Typography>
                        </div>

                        <div style={{ flexGrow: 1, display: "flex", justifyContent: "center", alignItems: "center" }}>
                          {i["gasValues"] != null ? (<>
                            {(Object.entries(i["gasValues"]).filter(([k, v]) => v["alert"] > 0).length === 0) ? (
                              <div className='text-normal'>Normal</div>
                            ) : (
                              <div className='text-alert'>Alert</div>
                            )}
                          </>) : (
                            <div>-</div>
                          )}
                        </div>
                      </div>

                      <div style={{ display: "flex", flexDirection: "column", justifyContent: "center", justifyContent: "center" }}>
                        <div style={{ width: "100%", display: "flex", justifyContent: "center", alignItems: "center" }}>
                          <Typography sx={{ display: '-webkit-box', overflow: 'hidden', WebkitBoxOrient: 'vertical', WebkitLineClamp: 1 }} variant="body1">
                            # Workers
                          </Typography>
                        </div>

                        <div style={{ flexGrow: 1, display: "flex", flexDirection: "column", alignItems: "center" }}>
                          <div style={{ display: "grid", gridTemplateColumns: "120px 10px auto" }}>
                            <div style={{ display: "flex" }}><span style={{ flex: 1, textAlign: "center" }}>{t("module_confinedSpace")}</span>:</div>
                            <div></div>
                            <div>{i["worker_num"]["in_tunnel"]}</div>

                            <div style={{ display: "flex" }}><span style={{ flex: 1, textAlign: "center" }}>Ground</span>:</div>
                            <div></div>
                            <div>{i["worker_num"]["on_ground"]}</div>
                          </div>
                        </div>
                      </div>
                    </Stack>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )
      })}
    </Slider>
  )
}

export default ZoneSlider